import React from 'react';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import Dot from '../../components/Dot';

const withDot = (text: string, col: string = color('info', 'dark')) => (
  <NuvoBox display="flex" flexDirection="row" alignItems="center" gap="4px">
    <Dot size={10} color={col} />
    {text}
  </NuvoBox>
);

export default withDot;
